var _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulseNegative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 28,
    viewBox: "0 0 146 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 49.4573,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 0 0)",
    stroke: "#97A6C8",
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 48.3333,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 48.3333 27)",
    stroke: "#97A6C8"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 49.4573,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 95.5426 0)",
    stroke: "#97A6C8"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 27,
    y2: -0.5,
    transform: "matrix(-6.48354e-08 1 1 2.94699e-08 49.4573 1)",
    stroke: "#97A6C8",
    strokeDasharray: "2 2"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 27,
    y2: -0.5,
    transform: "matrix(-6.48354e-08 1 1 2.94699e-08 96.6666 0)",
    stroke: "#97A6C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.1236 15.1768C95.2213 15.0791 95.2213 14.9209 95.1236 14.8232L93.5327 13.2322C93.435 13.1346 93.2767 13.1346 93.1791 13.2322C93.0815 13.3299 93.0815 13.4882 93.1791 13.5858L94.5933 15L93.1791 16.4142C93.0815 16.5118 93.0815 16.6701 93.1791 16.7678C93.2767 16.8654 93.435 16.8654 93.5326 16.7678L95.1236 15.1768ZM79.4706 15.25L94.9469 15.25L94.9469 14.75L79.4706 14.75L79.4706 15.25Z",
    fill: "#828FAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7102 11.6621H70.425V18H69.4924V11.6621H67.2122V10.8906H72.7102V11.6621ZM76.4993 18H75.5911V11.9795L73.7698 12.6484V11.8281L76.3577 10.8564H76.4993V18Z",
    fill: "#00CBAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.4043 15.1768C50.3067 15.0791 50.3067 14.9209 50.4043 14.8232L51.9953 13.2322C52.093 13.1346 52.2512 13.1346 52.3489 13.2322C52.4465 13.3299 52.4465 13.4882 52.3489 13.5858L50.9347 15L52.3489 16.4142C52.4465 16.5118 52.4465 16.6701 52.3489 16.7678C52.2512 16.8654 52.093 16.8654 51.9953 16.7678L50.4043 15.1768ZM66.0574 15.25L50.5811 15.25L50.5811 14.75L66.0574 14.75L66.0574 15.25Z",
    fill: "#828FAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.177 15.1768C145.274 15.0791 145.274 14.9209 145.177 14.8232L143.586 13.2322C143.488 13.1346 143.33 13.1346 143.232 13.2322C143.135 13.3299 143.135 13.4882 143.232 13.5858L144.647 15L143.232 16.4142C143.135 16.5118 143.135 16.6701 143.232 16.7678C143.33 16.8654 143.488 16.8654 143.586 16.7678L145.177 15.1768ZM128.73 15.25L145 15.25L145 14.75L128.73 14.75L128.73 15.25Z",
    fill: "#828FAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.626 11.6621H119.341V18H118.408V11.6621H116.128V10.8906H121.626V11.6621ZM127.104 18H122.446V17.3506L124.907 14.6162C125.272 14.2028 125.522 13.8675 125.659 13.6104C125.799 13.3499 125.869 13.0814 125.869 12.8047C125.869 12.4336 125.757 12.1292 125.532 11.8916C125.308 11.654 125.008 11.5352 124.634 11.5352C124.184 11.5352 123.835 11.6637 123.584 11.9209C123.336 12.1748 123.213 12.5296 123.213 12.9854H122.309C122.309 12.3311 122.519 11.8021 122.939 11.3984C123.363 10.9948 123.927 10.793 124.634 10.793C125.295 10.793 125.817 10.9671 126.201 11.3154C126.585 11.6605 126.777 12.1211 126.777 12.6973C126.777 13.3971 126.331 14.2305 125.439 15.1973L123.535 17.2627H127.104V18Z",
    fill: "#00CBAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M98.1826 15.1768C98.0849 15.0791 98.0849 14.9209 98.1826 14.8232L99.7735 13.2322C99.8712 13.1346 100.029 13.1346 100.127 13.2322C100.225 13.3299 100.225 13.4882 100.127 13.5858L98.7129 15L100.127 16.4142C100.225 16.5118 100.225 16.6701 100.127 16.7678C100.029 16.8654 99.8712 16.8654 99.7735 16.7678L98.1826 15.1768ZM114.629 15.25L98.3593 15.25L98.3593 14.75L114.629 14.75L114.629 15.25Z",
    fill: "#828FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseNegative);
export default __webpack_public_path__ + "static/media/pulse-negative.8c2129378d42234200dcd956a93f2c17.svg";
export { ForwardRef as ReactComponent };